<template>
    <div class="layout">
      <navbar :item="menuItem"/>
        <slot class="slot"></slot>
    </div>
</template>

<script>
    import Navbar from "./Navbar";

    export default {
      components: {Navbar},
      name: "layout",
      props:['menuItem']
    }
</script>

<style scoped>
  .layout {
    height:100%;
    width:100%;
    font-family: 'Roboto', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif !important;
    font-size: 1rem;
    position: absolute;

  }
  .slot {
    margin-bottom: 3rem;
    position: absolute;
    top:30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Layout.vue